<!-- <mat-form-field
  appearance="outline"
  class="language-selector"
  style="width: 102px; background-color: white; margin-bottom: -10px"
>
  <mat-label>{{ currentLabel }}</mat-label>

  <mat-select
    [value]="selectedLang.code"
    (selectionChange)="onLanguageChange($event.value)"
  > -->
<!-- Custom display when selected -->
<!-- <mat-select-trigger aria-hidden="true">
      <span style="display: flex; align-items: center">
        <img
          [src]="selectedLang.flag"
          role="presentation"
          alt=""
          width="20"
          height="14"
          style="margin-right: 8px"
        />
          ({{ selectedLang.code.toUpperCase() }})
      </span>
    </mat-select-trigger> -->

<!-- Language options -->
<!-- <mat-option
      *ngFor="let lang of languages"
      [value]="lang.code"
    >
      <div style="display: flex; align-items: center">
        <img
          [src]="lang.flag"
          role="presentation"
          alt=""
          width="20"
          height="14"
          style="margin-right: 8px"
        />
        {{ lang.name }} ({{ lang.code.toUpperCase() }})
      </div>
    </mat-option>
  </mat-select>
</mat-form-field> -->


<div style="width: 120px; position: relative;top:10px;margin: 0 5px;">
  <label class="floating-label" for="langSelect">
    {{ currentLabel }}
  </label>

  <kendo-dropdownlist id="langSelect" class="custom-kendo-dropdown" [data]="languages" textField="customText"
    valueField="code" [value]="selectedLang.code" (valueChange)="onLanguageChange($event)" [valuePrimitive]="true"
    [size]="'small'" [rounded]="'medium'" [fillMode]="'outline'" [popupSettings]="{width: 150}"
    [attr.aria-label]="currentLabel">
    <ng-template kendoDropDownListValueTemplate let-dataItem>
      <span>
        <img [src]="selectedLang?.flag" role="presentation" alt="" width="20" height="14" style="margin-right: 8px" />
        ({{ selectedLang?.code?.toUpperCase() }})
      </span>
    </ng-template>

    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <div>
        <img [src]="dataItem.flag" role="presentation" alt="" width="20" height="14" style="margin-right: 8px" />
        {{ dataItem.name }} ({{ dataItem.code.toUpperCase() }})
      </div>
    </ng-template>
  </kendo-dropdownlist>
</div>